import mitt from 'mitt'
const VueEvent = mitt();

export default VueEvent;